(function () {
    'use strict';

    angular.module('swif', [
        'swif.interventions',
        'swif.achats',
        'swif.patrimoine',
        'swif.fluid',
        'swif.reservations',
        'swif.parcauto',
        'swif.openbase',
        'swif.carto',
        'swif.publicLightning'
    ]);

    angular.module('swif.templates', []);

    angular.module('swif.achats', ['swif.framework']);

    angular.module('swif.ui', [
        'swif.framework',
        'swif.templates',
        'd3gauge',
        'ui.calendar',
        'ui.keypress',
        'ui.select',
        'ui.tinymce',
        'angular-leaflet',
        'picardy.fontawesome',
        'nvd3',
        'ngIdle'
    ]);
    angular.module('swif.framework', [
        'angularMoment',
        'ngRoute',
        'ui.bootstrap',
        'ngMessages',
        'ngProgress',
        'ngStorage',
        'ngSanitize',
        'gettext',
        'tmh.dynamicLocale',
        'jlareau.pnotify',
        'ngIdle'
    ]);
    angular.module('swif.carto', [
        'swif.ui',
        'osm'
    ]);
    angular.module('swif.interventions', [
        'swif.ui',
        'gantt',
        'gantt.groups',
        'gantt.tree',
        'gantt.tooltips'
    ]);
    angular.module('swif.reservations', ['swif.ui']);
    angular.module('swif.openbase', ['swif.ui']);
    angular.module('swif.patrimoine', ['swif.ui']);
    angular.module('swif.fluid', ['swif.ui']);
    angular.module('swif.parcauto', ['swif.ui']);
    angular.module('swif.publicLightning', ['swif.ui']);

    angular.module('swif')
    .config(configSwif)
    .run(runSwif);


    function runSwif ($http, gettextCatalog, amMoment, $interval, settingsService, tmhDynamicLocale, swifOpenbaseLanguageService) {
        // We respect the IETF language tag here (e.g en-CA), keeping the region tag in uppercase
        // Moment.js handles this very well
        const languages = ['fr', 'en', 'es'];
        languages.forEach(lng => {
            $http.get(`translations/${lng}.json`).then(function (translations) {
                gettextCatalog.setStrings(lng, translations.data[lng]);
                return true;
            });
        });

        function reloadIfVersionChanged() {
            var random = Math.random();
            $http.get('version.txt?' + random)
            .then(function (version) {
                var v = version.data.trim();
                if (v !== SWIF_RESOURCES_VERSION) {
                    window.location.reload(true);
                }
            }, function () {
                console.log('can t get config');
            });
        }
        $interval(reloadIfVersionChanged, 3600000, 0, false);

        Raven.config('https://ebe26e9a46f3404da55dc9014487e934@sentry.atreal-ouest.fr/3', {
            release: SWIF_RESOURCES_VERSION
        })
            .addPlugin(Raven.Plugins.Angular)
            .install();

        settingsService.initialize().then(function (settings) {
            const storedLanguage = window.localStorage.getItem('language');
            if (storedLanguage) {
                swifOpenbaseLanguageService.applyLang(storedLanguage);
            } else {
                swifOpenbaseLanguageService.applyLang();
            }

            /** Matomo */
            if (settingsService.app.matomo_code) {
                window['_paq'] = window['_paq'] || [];
                /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
                // Previously useful but not anymore?? We keep it just in case...
                // window['_paq'].push(["setCookieDomain", settingsService.app.matomo_domain || "*.opengst.fr"]);
                window['_paq'].push(['trackPageView']);
                window['_paq'].push(['enableLinkTracking']);
                var u = "//matomo.nautilux.net/";
                window['_paq'].push(['setTrackerUrl', u + 'matomo.php']);
                window['_paq'].push(['setSiteId', settingsService.app.matomo_code]);
                var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
                g.type = 'text/javascript'; g.async = true; g.defer = true; g.src = u + 'piwik.js'; s.parentNode.insertBefore(g, s);
            }
        });
    }
    runSwif.$inject = ['$http', 'gettextCatalog', 'amMoment', '$interval', 'settingsService', 'tmhDynamicLocale', 'swifOpenbaseLanguageService']

    function configSwif($uibTooltipProvider, notificationServiceProvider, $compileProvider, $provide, tmhDynamicLocaleProvider) {
        tmhDynamicLocaleProvider.localeLocationPattern('angular-locale_{{locale}}.js');

        $uibTooltipProvider.options({
            appendToBody: false
        });
        notificationServiceProvider.setDefaultStack('top_left');
        notificationServiceProvider.setDefaults({
            delay: 2000
        });
        $provide.decorator('uiTinymceDirective', ['$delegate', function($delegate) {
            $delegate[0].priority = 10;
            return $delegate;
        }]);
    }
    configSwif.$inject = ['$uibTooltipProvider', 'notificationServiceProvider', '$compileProvider', '$provide', 'tmhDynamicLocaleProvider'];

})();
